import { put, select, takeLatest } from 'redux-saga/effects'
import { CustomSignaturesConstants } from '../store/customSignature.constants'
import { ICustomFormsSignatureState, IPrFormSignatureState } from '../store/customSignature.types'
import { getCustomSignaturesSelector } from '../selectors/getCustomSignature.selectors'
import {
  resetCustomSignatureClientData,
  saveCustomSignatureToPcr,
  saveCustomSignatures,
  savePrFormsCustom,
} from '../store/customSignature.actions'
import Logger from '../../../services/logger.service'

export function* customSignatureDeleteChip() {
  try {
    const customSignature: ICustomFormsSignatureState = yield select(getCustomSignaturesSelector)
    const { customSignatureClientData, prFormsCustom, prFormsSignature } = customSignature
    const { deleteChipId } = customSignatureClientData

    if (deleteChipId.formId && deleteChipId.signatureId) {
      const index = prFormsSignature.findIndex(
        (chipObject: IPrFormSignatureState) =>
          chipObject.formId === deleteChipId.formId && chipObject.signatureId === deleteChipId.signatureId
      )
      if (index >= 0) {
        prFormsCustom.splice(index, 1)
        prFormsSignature.splice(index, 1)
        yield put(saveCustomSignatures(prFormsSignature))
        yield put(savePrFormsCustom(prFormsCustom))
        yield put(resetCustomSignatureClientData())
        yield put(saveCustomSignatureToPcr())
      }
    }
  } catch (e) {
    Logger.error(`customSignatureDeleteChip() error: ${e}`)
  }
}
export function* customSignatureDeleteChipSaga() {
  yield takeLatest([CustomSignaturesConstants.SET_DELETE_CHIP_ID], customSignatureDeleteChip)
}
